import { render, staticRenderFns } from "./TableInvoices.vue?vue&type=template&id=c3821fd4&scoped=true"
import script from "./TableInvoices.vue?vue&type=script&lang=js"
export * from "./TableInvoices.vue?vue&type=script&lang=js"
import style0 from "./TableInvoices.vue?vue&type=style&index=0&id=c3821fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3821fd4",
  null
  
)

export default component.exports